import { mutatorAction } from 'satcheljs';
import { getAppStore } from '../../../../@data';
import { LOCAL_STORAGE_SHOW_REPORT_UNSAVED_DIALOG_KEY } from '../store/store';

const userId = getAppStore().userContext?.id;
export const onChangeShowUnsavedDialog = mutatorAction('onChangeShowUnsavedDialog', () => {
  if (!userId) {
    return;
  }
  const localValue = JSON.parse(localStorage.getItem(LOCAL_STORAGE_SHOW_REPORT_UNSAVED_DIALOG_KEY) ?? '[]');
  if (!Array.isArray(localValue)) {
    localStorage.setItem(LOCAL_STORAGE_SHOW_REPORT_UNSAVED_DIALOG_KEY, JSON.stringify([userId]));
  }
  localStorage.setItem(LOCAL_STORAGE_SHOW_REPORT_UNSAVED_DIALOG_KEY, JSON.stringify([...localValue, userId]));
});

export const getShowReportUnsavedDialog = (): boolean => {
  const localValue = JSON.parse(localStorage.getItem(LOCAL_STORAGE_SHOW_REPORT_UNSAVED_DIALOG_KEY) ?? '[]');
  return !Array.isArray(localValue) || !localValue.includes(userId);
};
